import { t as tuple } from './types-6f6b2fba.js';

const buttonModes = tuple('filled', 'outlined', 'text');
const buttonVersions = tuple('primary', 'secondary', 'monochrome', 'success', 'error', 'danger', 'warning', 'info');

export { buttonVersions as a, buttonModes as b };
